<template>
  <!-- Breadcrumb -->
  <div class="subtitle-container">
    <ul>
      <li class="breadcrumb d-inline">
        <a href="/home">Introdução</a>
      </li>
      <li class="breadcrumb d-inline">
        <span class="divider">
          <font-awesome-icon :icon="['fas', 'fa-angle-right']" />
        </span>
      </li>
      <li class="breadcrumb d-inline">
        <a href="/register">Registo</a>
      </li>
      <li class="breadcrumb d-inline">
        <span class="divider">
          <font-awesome-icon :icon="['fas', 'fa-angle-right']" />
        </span>
      </li>
      <li class="breadcrumb d-inline">
        <span>Questionário</span>
      </li>
    </ul>
  </div>

  <!-- Page Title -->
  <div class="title-container">
    <h2 class="primary-title">
      Auto-diagnóstico em matérias de descarbonização
    </h2>
  </div>

  <!-- Horizontal Stepper -->
  <div
    aria-orientation="horizontal"
    role="tablist"
    linear="true"
    labelposition="bottom"
    class="mat-stepper-horizontal mat-stepper-label-position-bottom"
  >
    <div class="mat-horizontal-stepper-header-container">
      <div
        v-for="(sectionInfo, index) in sections"
        :key="sectionInfo.section_Id"
        :class="[
          'step-container',
          {
            'filled-both':
              filledSections.has(sectionInfo.section_Id) &&
              filledSections.has(sections[index - 1]?.section_Id),
            'filled-next':
              filledSections.has(sectionInfo.section_Id) &&
              !(
                filledSections.has(sectionInfo.section_Id) &&
                filledSections.has(sections[index + 1]?.section_Id) &&
                filledSections.has(sections[index - 1]?.section_Id)
              ) &&
              !(
                filledSections.has(sections[index - 1]?.section_Id) &&
                !filledSections.has(sections[index + 1]?.section_Id)
              ) &&
              !(
                filledSections.has(sectionInfo.section_Id) &&
                filledSections.has(sections[index - 1]?.section_Id)
              ),
            'filled-previous':
              filledSections.has(sections[index - 1]?.section_Id) &&
              !(
                filledSections.has(sectionInfo.section_Id) &&
                filledSections.has(sections[index - 1]?.section_Id)
              ),
          },
        ]"
      >
        <div class="circle-container">
          <div
            role="tab"
            class="mat-step-header mat-focus-indicator mat-horizontal-stepper-header mat-primary col-lg-2"
            v-on:click="changeSection(sectionInfo.section_Id, null)"
          >
            <div
              :id="'circle' + sectionInfo.section_Id"
              class="mat-step-icon"
              :class="{
                'mat-step-icon-selected': section === sectionInfo.section_Id,
                'mat-step-icon-active':
                  filledSections.has(sectionInfo.section_Id) &&
                  section !== sectionInfo.section_Id,
              }"
            >
              <div
                class="mat-step-icon-content"
                :class="{
                  'mat-step-icon-content-selected':
                    section === sectionInfo.section_Id,
                }"
              >
                <font-awesome-icon :icon="['fas', sectionInfo.section_Icon]" />
              </div>
            </div>
          </div>
        </div>
        <div class="mat-stepper-horizontal-line"></div>
        <div
          :id="'circleLabel' + sectionInfo.section_Id"
          class="mat-step-label"
          :class="{
            'mat-step-label-selected': section === sectionInfo.section_Id,
          }"
        >
          <div class="mat-step-text-label">{{ sectionInfo.section_Desc }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section Title -->
  <div>
    <h2 class="secondary-title mb-5">
      {{ section }} - {{ sectionDescription }}
    </h2>
  </div>

  <!-- Questions -->
  <form @submit.prevent="submitForm()">
    <!-- General loop through the questions -->
    <div v-for="questionInfo in questions" :key="questionInfo.question_Id">
      <div class="questionnaire">
        <!---------------------------------------------------------------->
        <!-- Template exclusive for questions with type UserInputDetail -->
        <!---------------------------------------------------------------->
        <template v-if="questionInfo.question_Type === 'UserInputDetail'">
          <!-- Question text -->
          <p
            class="question-label"
            :class="{
              invalid:
                invalidQuestions.includes(questionInfo.question_Id) &&
                validationTriggered,
            }"
            :for="questionInfo.question_Id"
          >
            {{ questionInfo.question_Id }}. {{ questionInfo.question_Desc }}
          </p>
          <!-- Table for products -->
          <div class="subquestions-container table-responsive">
            <table class="product-table custom-width-table">
              <thead>
                <tr>
                  <th class="product-name-column">Nome do Produto</th>
                  <th class="product-process-column">Processo produtivo</th>
                </tr>
              </thead>
              <tbody>
                <!-- Loop through answers -->
                <tr
                  v-for="answer in selectedAnswers[questionInfo.question_Id]"
                  :key="answer.Answer_Id"
                >
                  <!-- Display UserInput -->
                  <td>
                    <div class="question-02">
                      <textarea
                        type="text"
                        class="user-input-02"
                        :id="
                          'answer_' +
                          questionInfo.question_Id +
                          '_' +
                          answer.Answer_Id
                        "
                        :name="'answer_' + questionInfo.question_Id"
                        :value="
                          selectedAnswers[questionInfo.question_Id]
                            ?.find(
                              (item) => item.Answer_Id === answer.Answer_Id
                            )
                            ?.User_Answer.split(':')[0] || ''
                        "
                        @change="
                          handleUserDetailInput(
                            questionInfo.question_Id,
                            answer.Answer_Id,
                            $event.target.value,
                            'name'
                          )
                        "
                        :class="{
                          invalid:
                            isFieldInvalid(answer.Answer_Id, 'name') &&
                            productTrigger,
                        }"
                      ></textarea>
                    </div>
                  </td>
                  <!-- Display TextArea -->
                  <td>
                    <div class="textarea-container-02">
                      <textarea
                        type="text"
                        class="user-input-02"
                        :id="
                          'answer_' +
                          questionInfo.question_Id +
                          '_' +
                          answer.Answer_Id
                        "
                        :name="'answer_' + questionInfo.question_Id"
                        :value="
                          selectedAnswers[questionInfo.question_Id]
                            ?.find(
                              (item) => item.Answer_Id === answer.Answer_Id
                            )
                            ?.User_Answer.split(':')[1] || ''
                        "
                        maxlength="1000"
                        @input="
                          handleUserDetailInput(
                            questionInfo.question_Id,
                            answer.Answer_Id,
                            $event.target.value,
                            'process'
                          )
                        "
                        :disabled="
                          isProductNameEmpty(
                            questionInfo.question_Id,
                            answer.Answer_Id
                          )
                        "
                        :class="{
                          invalid:
                            isFieldInvalid(answer.Answer_Id, 'process') &&
                            productTrigger,
                        }"
                      ></textarea>
                      <div class="char-limit">
                        Caracteres:
                        {{
                          formatNumber(
                            getUserInputValue(
                              questionInfo.question_Id,
                              answer.Answer_Id,
                              false
                            ).length || 0
                          )
                        }}
                        / 1.000
                      </div>
                    </div>
                  </td>
                  <!-- Display Remove button if more than one row -->
                  <td
                    v-if="selectedAnswers[questionInfo.question_Id].length > 1"
                  >
                    <button
                      type="button"
                      @click.prevent="
                        removeRowProducts(
                          questionInfo.question_Id,
                          answer.Answer_Id
                        )
                      "
                      class="btn-remove"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Display Add row button if less than 20 products-->
            <div class="text-align-left">
              <button
                type="button"
                v-if="selectedAnswers[questionInfo.question_Id]?.length < 20"
                @click.prevent="addRowProducts(questionInfo.question_Id)"
                class="btn-add"
              >
                <font-awesome-icon :icon="['fas', 'fa-square-plus']" />
                Adicionar produto
              </button>
            </div>
          </div>
        </template>
        <!------------------------------------------------------------------->
        <!-- Template exclusive for questions that don't have subquestions -->
        <!------------------------------------------------------------------->
        <template v-else-if="questionInfo.subQuestion.length === 0">
          <!-- Question text -->
          <p
            class="question-label"
            :class="{
              invalid:
                invalidQuestions.includes(questionInfo.question_Id) &&
                validationTriggered,
            }"
            :for="questionInfo.question_Id"
            v-html="formatAsteriskQuestion(questionInfo)"
          ></p>
          <!-- Loop through the answers of each question -->
          <div v-for="(value, key) in questionInfo.answers" :key="key">
            <!-------------------------------------------------->
            <!-- Cases in which the answer is a UserInputText -->
            <template v-if="questionInfo.question_Type === 'UserInputText'">
              <!-- Display textarea -->
              <div class="textarea-container">
                <textarea
                  type="text"
                  class="user-input"
                  :id="'answer_' + questionInfo.question_Id + '_' + key"
                  :name="'answer_' + questionInfo.question_Id"
                  :value="
                    selectedAnswers[questionInfo.question_Id]?.find(
                      (item) => item.Answer_Id === key
                    )?.User_Answer || ''
                  "
                  maxlength="1000"
                  @input="
                    handleUserInput(
                      questionInfo.question_Id,
                      key,
                      $event.target.value
                    )
                  "
                  @blur="resetValidation(questionInfo.question_Id)"
                ></textarea>
                <div class="char-limit">
                  Caracteres:
                  {{
                    formatNumber(
                      getUserInputValue(questionInfo.question_Id, key).length ||
                        0
                    )
                  }}
                  / 1.000
                </div>
              </div>
            </template>
            <!----------------------------------------------------->
            <!-- Cases in which the answer is a UserInputNumeric -->
            <template v-if="questionInfo.question_Type === 'UserInputNumeric'">
              <!-- Error message specific for percentage answers -->
              <p v-if="percentageTrigger" class="error-message">
                O valor inserido deve ser entre 0 e 100
              </p>
              <!-- Display number input -->
              <input
                type="number"
                step="0.01"
                pattern="\d{1,12}"
                class="user-input-number"
                :id="'answer_' + questionInfo.question_Id + '_' + key"
                :name="'answer_' + questionInfo.question_Id"
                :value="
                  selectedAnswers[questionInfo.question_Id]?.find(
                    (item) => item.Answer_Id === key
                  )?.User_Answer || ''
                "
                @change="
                  handleUserInput(
                    questionInfo.question_Id,
                    key,
                    $event.target.value
                  )
                "
                @blur="
                  resetValidation(questionInfo.question_Id);
                  percentageTrigger = false;
                "
              />
            </template>
            <!------------------------------------------------->
            <!-- Cases in which the answer is a SingleSelect -->
            <template v-if="questionInfo.question_Type === 'SingleSelect'">
              <!-- Display radio check -->
              <input
                type="radio"
                :id="'answer_' + questionInfo.question_Id + '_' + key"
                :name="'answer_' + questionInfo.question_Id"
                :value="key"
                @click="handleRadioChange(questionInfo.question_Id, key)"
              />
              <!-- Display answer text -->
              <label
                class="radio_answers"
                :class="{
                  checked: isChecked(questionInfo.question_Id, key),
                }"
                :for="'answer_' + questionInfo.question_Id + '_' + key"
                v-html="formatAsteriskAnswer(value)"
              ></label>
            </template>
            <!------------------------------------------------>
            <!-- Cases in which the answer is a MultiSelect -->
            <template v-if="questionInfo.question_Type === 'MultiSelect'">
              <!-- In case there is an option with checkbox + text input -->
              <div v-if="value === 'Outra(s). Qual/Quais?'">
                <!-- Display checkbox -->
                <input
                  type="checkbox"
                  :id="'answer_' + questionInfo.question_Id + '_' + key"
                  :name="'answer_' + questionInfo.question_Id"
                  :value="key"
                  @change="
                    handleMultiSelect(
                      questionInfo.question_Id,
                      key,
                      value,
                      $event
                    )
                  "
                />
                <!-- Display answer text -->
                <label
                  class="checkbox_answers"
                  :class="{
                    checked: selectedAnswers[questionInfo.question_Id]?.some(
                      (answer) => answer.Answer_Id === key
                    ),
                  }"
                  :for="'answer_' + questionInfo.question_Id + '_' + key"
                  v-html="formatAsteriskAnswer(value)"
                ></label>
                <!-- Display text input bellow the option for user to enter text -->
                <div class="textarea-container">
                  <textarea
                    v-if="
                      this.selectedAnswers[questionInfo.question_Id]?.findIndex(
                        (item) => item.Answer_Id === key
                      ) !== -1
                    "
                    type="text"
                    class="user-input"
                    :id="'answer_' + questionInfo.question_Id + '_' + key"
                    :name="'answer_' + questionInfo.question_Id"
                    maxlength="1000"
                    :value="
                      selectedAnswers[questionInfo.question_Id]?.find(
                        (item) => item.Answer_Id === key
                      )?.User_Answer || ''
                    "
                    @input="
                      handleUserInput(
                        questionInfo.question_Id,
                        key,
                        $event.target.value
                      )
                    "
                  ></textarea>
                  <div
                    class="char-limit"
                    v-if="
                      this.selectedAnswers[questionInfo.question_Id]?.findIndex(
                        (item) => item.Answer_Id === key
                      ) !== -1
                    "
                  >
                    Caracteres:
                    {{
                      formatNumber(
                        getUserInputValue(questionInfo.question_Id, key)
                          .length || 0
                      )
                    }}
                    / 1.000
                  </div>
                </div>
              </div>
              <!-- In case of normal checkbox answer without text input -->
              <div v-else>
                <!-- Display checkbox -->
                <input
                  type="checkbox"
                  :id="'answer_' + questionInfo.question_Id + '_' + key"
                  :name="'answer_' + questionInfo.question_Id"
                  :value="key"
                  @input="
                    handleMultiSelect(
                      questionInfo.question_Id,
                      key,
                      value,
                      $event
                    )
                  "
                />
                <!-- Display answer text -->
                <label
                  class="checkbox_answers"
                  :class="{
                    checked: selectedAnswers[questionInfo.question_Id]?.some(
                      (answer) => answer.Answer_Id === key
                    ),
                  }"
                  :for="'answer_' + questionInfo.question_Id + '_' + key"
                  v-html="formatAsteriskAnswer(value)"
                ></label>
              </div>
            </template>
            <!----------------------------------------------->
            <!-- Cases in which the answer is a FileUpload -->
            <template v-if="questionInfo.question_Type === 'FileUpload'">
              <!-- Display file for user to download and fill out if needed -->
              <div
                v-if="questionInfo.question_Desc.includes('link')"
                class="download-template-text"
              >
                Por favor descarregue o documento para preencher:
                <a
                  href="#"
                  @click.prevent="handleDownloadTemplate"
                  class="download-template-link"
                >
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                  <span>Iniciativas e projetos de descarbonizão</span>
                </a>
              </div>
              <div>
                <!-- Display the file input to receive file -->
                <label class="btn custom-file-upload">
                  <input
                    type="file"
                    :key="fileInputKey"
                    accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/zip,application/x-zip-compressed,text/plain,.doc,.docx,.xls,.xlsx,.pdf,.zip,.txt"
                    @input="
                      handleFileUpload(questionInfo.question_Id, key, $event);
                      resetValidation(questionInfo.question_Id);
                    "
                  />
                  <font-awesome-icon :icon="['fas', 'fa-file-import']" />
                  Selecionar ficheiro
                </label>
                <span
                  class="custom-filename"
                  v-if="
                    selectedAnswers[questionInfo.question_Id] &&
                    selectedAnswers[questionInfo.question_Id].FileName
                  "
                >
                  {{ selectedAnswers[questionInfo.question_Id]?.FileName }}
                  <button
                    type="button"
                    @click.prevent="
                      removeUploadedFile(questionInfo.question_Id)
                    "
                    class="btn-remove"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </span>
              </div>
              <div class="char-limit">Tamanho máximo do ficheiro: 10MB</div>
              <!-- Display if the file is to large -->
              <div v-if="fileUploadError" class="size-error" style="color: red">
                {{ fileUploadError }}
              </div>
            </template>
            <!--------------------------------------------------->
            <!-- Cases in which the answer is a DropdownSelect -->
            <template v-if="questionInfo.question_Type === 'DropdownSelect'">
              <!-- Display searchable dropdown -->
              <div class="form-group">
                <multiselect
                  track-by="id"
                  v-model="Company_Cae"
                  :custom-label="idAndDescription"
                  label="description"
                  placeholder="Selecione um CAE"
                  :options="CAE"
                  :searchable="true"
                  :allow-empty="true"
                >
                </multiselect>
              </div>
            </template>
            <!---------------------------------------------------------------------->
            <!-- Cases in which the answer is a UserInputDetail_Dropdown_Checkbox -->
            <template
              v-if="
                questionInfo.question_Type ===
                'UserInputDetail_Dropdown_Checkbox'
              "
            >
              <div class="row">
                <div class="location-container">
                  <div class="subquestions-container">
                    <table class="location-table">
                      <thead>
                        <tr>
                          <th>Localização</th>
                          <th>Morada</th>
                          <th>Código Postal</th>
                          <th>Concelho</th>
                          <th>
                              CELE
                                <div class="glossary-tooltip">
                                  <span class="glossary-term-cele">*</span>
                                  <span class="tooltip-text">Ver glossário</span>
                                </div>      
                            </th>   
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in Location_Data" :key="index">
                          <!-- Localização -->
                          <td>
                            <div
                              class="form-group"
                              :class="{
                                'is-invalid': isInvalidLocation(index),
                              }"
                            >
                              <input
                                type="text"
                                v-model="Location_Data[index].description"
                                :placeholder="index === 0 ? '' : ' '"
                                class="form-control"
                                @blur="
                                  removeInvalidLocation(index);
                                  resetValidation(questionInfo.question_Id);
                                "
                              />
                            </div>
                          </td>

                          <!-- Q0.3.2 Morada -->
                          <td>
                            <div
                              class="form-group"
                              :class="{
                                'is-invalid': isInvalidLocation(index),
                              }"
                            >
                              <input
                                type="text"
                                v-model="Location_Data[index].address"
                                :placeholder="index === 0 ? '' : ''"
                                class="form-control"
                                @blur="
                                  removeInvalidLocation(index);
                                  resetValidation(questionInfo.question_Id);
                                "
                              />
                            </div>
                          </td>

                          <!-- Q0.3.3 ZIP -->
                          <td>
                            <div
                              class="form-group"
                              :class="{
                                'is-invalid':
                                  isInvalidLocation(index) ||
                                  (isInvalidPostalCode(index) && zipTrigger),
                              }"
                            >
                              <input
                                type="text"
                                v-model="Location_Data[index].postal_Code"
                                :placeholder="index === 0 ? '' : ''"
                                class="form-control zip-code-input"
                                maxlength="8"
                                @input="formatPostalCode(index, $event)"
                                @blur="
                                  removeInvalidLocation(index);
                                  resetValidation(questionInfo.question_Id);
                                "
                              />
                            </div>
                          </td>

                          <!-- Q0.3.4 Concelho -->
                          <td>
                            <div
                              class="form-group"
                              :class="{
                                'is-invalid': isInvalidLocation(index),
                              }"
                            >
                              <Multiselect
                                v-model="Location_Data[index].municipality"
                                :options="Municipalities"
                                :searchable="true"
                                :close-on-select="true"
                                :show-labels="false"
                                placeholder="Concelho"
                                @close="
                                  removeInvalidLocation(index);
                                  resetValidation(questionInfo.question_Id);
                                "
                              ></Multiselect>
                            </div>
                          </td>

                          <!-- Q0.3.5 CELE -->
                          <td>
                            <div class="cele-wrapper mt-2">
                              <input
                                :id="'cele-checkbox-' + index"
                                type="checkbox"
                                v-model="Location_Data[index].cele"
                              />
                              <label :for="'cele-checkbox-' + index"></label>
                            </div>
                          </td>

                          <!-- Apagar linha -->
                          <td v-if="Location_Data.length > 1">
                            <button
                              type="button"
                              @click="removeRowLocalizations(index)"
                              class="btn-remove mt-2"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="text-align-left">
                      <button
                        type="button"
                        @click="addRowLocalizations"
                        class="btn-add"
                      >
                        <font-awesome-icon :icon="['fas', 'fa-square-plus']" />
                        Adicionar localização
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
        <!------------------------------------------------------------->
        <!-- Template exclusive for questions that have subquestions -->
        <!------------------------------------------------------------->
        <template v-else>
          <!-- Question text -->
          <p
            class="question-label"
            :for="questionInfo.question_Id"
            :class="{
              invalid:
                invalidQuestions.includes(questionInfo.question_Id) &&
                validationTriggered,
            }"
            v-html="formatAsteriskQuestion(questionInfo)"
          ></p>
          <!----------------------------------->
          <!-- Table for SingleSelectByLevel -->
          <template v-if="questionInfo.question_Type === 'SingleSelectByLevel'">
            <div class="subquestions-container table-responsive">
              <!-- Table for question content -->
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <!-- Legend on top -->
                    <th
                      v-for="option in questionInfo.questionType
                        .questionType_Answers"
                      :key="option"
                      v-html="formatAsteriskAnswer(option.answer)"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Loop through each subquestion -->
                  <tr
                    v-for="subquestion in questionInfo.subQuestion"
                    :key="subquestion"
                  >
                    <!-- Display subQuestion text -->
                    <td
                      class="subquestion-label"
                      v-html="
                        formatAsteriskAnswer(subquestion.subQuestion_Desc)
                      "
                    ></td>
                    <!-- Loop through each possible answer inside each subquestion -->
                    <td
                      class="subquestion-answer"
                      v-for="option in questionInfo.questionType
                        .questionType_Answers"
                      :key="option.id"
                    >
                      <!-- Display radio check -->
                      <input
                        type="radio"
                        :id="subquestion.subQuestion_Id + '_' + option.id"
                        :name="subquestion.subQuestion_Id"
                        :value="option.id"
                        @click="
                          handleUserInputSSBL(
                            subquestion.subQuestion_Id,
                            Object.keys(subquestion.answers)[0],
                            option.answer
                          )
                        "
                        @input="resetValidation(questionInfo.question_Id)"
                      />
                      <label
                        class="radio_answers"
                        :class="{
                          checked: isChecked(
                            subquestion.subQuestion_Id,
                            Object.keys(subquestion.answers)[0],
                            option.answer
                          ),
                        }"
                        :for="subquestion.subQuestion_Id + '_' + option.id"
                      ></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <!----------------------------->
          <!-- Table for MultiCheckbox -->
          <template v-if="questionInfo.question_Type === 'MultiCheckbox'">
            <div class="subquestions-container table-responsive">
              <!-- Table for question content -->
              <table>
                <thead>
                  <tr>
                    <!-- Legend on top -->
                    <th></th>
                    <th>
                      Identifique as iniciativas de descarbonização que conhece
                    </th>
                    <th>
                      Indique quais destas iniciativas de descarbonização aplica
                      na sua empresa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Loop through each subquestion -->
                  <tr
                    v-for="subquestion in questionInfo.subQuestion"
                    :key="subquestion"
                  >
                    <!-- Display subQuestion text -->
                    <td
                      class="subquestion-label"
                      v-html="
                        formatAsteriskAnswer(subquestion.subQuestion_Desc)
                      "
                    ></td>
                    <!-- Loop through each possible answer inside each subquestion -->
                    <td
                      class="subquestion-answer"
                      v-for="(value, key) in subquestion.answers"
                      :key="key"
                    >
                      <!-- Display checkbox -->
                      <input
                        type="checkbox"
                        :id="subquestion.subQuestion_Id + '_' + key"
                        :name="subquestion.subQuestion_Id + '_' + key"
                        :value="true"
                        @change="
                          handleCheckbox(subquestion.subQuestion_Id, key)
                        "
                      />
                      <label
                        class="radio_answers"
                        :class="{
                          checked: isChecked(
                            subquestion.subQuestion_Id,
                            key,
                            'true'
                          ),
                        }"
                        :for="subquestion.subQuestion_Id + '_' + key"
                      ></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <!-------------------->
          <!-- MultiUserInput -->
          <template v-if="questionInfo.question_Type === 'MultiUserInput'">
            <div class="subquestions-container table-responsive">
              <!-- Header -->
              <div class="subquestion">
                <!-- Empty cell for alignment -->
                <p class="subquestion-label"></p>
                <!-- Label Cells -->
                <div class="input-container">
                  <div class="header-cell header-cell-input">
                    {{ priorYear }}
                  </div>
                  <div class="header-cell header-cell-input">
                    {{ currentYear }}
                  </div>
                </div>
              </div>

              <!-- Header Separator -->
              <hr />

              <!-- Loop through each subQuestion -->
              <div
                class="subquestion"
                v-for="subQuestion in questionInfo.subQuestion"
                :key="subQuestion.subQuestion_Id"
              >
                <!-- Display subQuestion text -->
                <p
                  class="subquestion-label"
                  v-html="formatAsteriskAnswer(subQuestion.subQuestion_Desc)"
                ></p>
                <div class="input-container">
                  <!-- Loop through each answer for each subQuestion -->
                  <template
                    v-for="(value, key) in subQuestion.answers"
                    :key="key"
                  >
                    <!-- Display input boxes for each answer -->
                    <input
                      type="number"
                      step="0.01"
                      pattern="\d{1,12}"
                      class="user-input-number"
                      :id="'answer_' + key"
                      :name="'answer_' + key"
                      :value="
                        selectedAnswers[subQuestion.subQuestion_Id]?.find(
                          (item) => item.Answer_Id === key
                        )?.User_Answer
                      "
                      v-on:change="
                        handleUserInputSubQuestions(
                          subQuestion.subQuestion_Id,
                          key,
                          $event.target.value
                        )
                      "
                      @blur="resetValidation(questionInfo.question_Id)"
                    />
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>

    <!-- Unanswered questions pop-up -->
    <div class="submission-check">
      <!-- When pop-up open create overlay outside it to click and close -->
      <div v-if="showSubmissionCheck" class="submission-check-overlay"></div>
      <!-- Content to show when Pop-up open -->
      <div v-if="showSubmissionCheck" class="submission-check-popup">
        <div class="submission-check-content">
          <!-- X button to close Pop-up -->
          <span class="close" @click="showSubmissionCheck = false"
            >&times;</span
          >
          <!-- Title -->
          <h3>Questões por responder</h3>
          <p>As seguintes questões não se encontram respondidas:</p>
          <!-- List of unanswered questions -->
          <div class="submission-check-list">
            <div
              v-for="(questions, section) in groupedInvalidQuestions"
              :key="section"
            >
              <h5>Secção {{ section }}:</h5>
              <ul>
                <li
                  v-for="questionId in questions"
                  :key="questionId"
                  class="mb-2"
                >
                  <strong>{{ questionId }}</strong> -
                  {{ questionMap[questionId].description }}
                </li>
              </ul>
            </div>
          </div>
          <!-- Buttons -->
          <div class="submission-check-buttons">
            <p class="mt-3">Ainda assim, deseja submeter o questionário?</p>
            <div class="submission-check-buttons-container">
              <button
                class="btn btn-cancel"
                @click.prevent="reviseSurveyWithValidation()"
              >
                Cancelar
              </button>
              <button
                class="btn"
                @click.prevent="
                  submitForm(true);
                  this.showSubmissionCheck = false;
                "
              >
                Submeter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Buttons -->
    <div
      class="form-footer d-flex align-items-center justify-content-between pt-5"
    >
      <div class="btnsubmit div-button-questionnaire">
        <div
          v-if="this.section === 'S0'"
          class="sabermais w-100 d-flex align-items-center transition btnSubmitText"
          id="div-button-questionnaire-previous"
          v-on:click="X"
        >
          <div class="arrow float-right rotate-left arrow-left">
            <div class="linha"></div>
            <div class="triangulo"></div>
          </div>
          <div class="float-right mr-3 label button_left button_questionnaire">
            <a href="/register" style="color: inherit; text-decoration: none"
              >Anterior</a
            >
          </div>
        </div>
        <div
          v-if="this.section !== 'S0'"
          class="sabermais w-100 d-flex align-items-center transition btnSubmitText"
          id="div-button-questionnaire-previous"
          v-on:click="changeSection(null, false)"
        >
          <div class="arrow float-right rotate-left arrow-left">
            <div class="linha"></div>
            <div class="triangulo"></div>
          </div>
          <div class="float-right mr-3 label button_left button_questionnaire">
            Anterior
          </div>
        </div>
      </div>
      <!-- Button Next -->
      <div
        class="btnsubmit div-button-questionnaire"
        id="div-button-questionnaire-next"
      >
        <div
          v-if="this.section !== 'S6'"
          class="sabermais w-100 d-flex align-items-center transition btnSubmitText"
          v-on:click="changeSection(null, true)"
        >
          <div
            class="float-left mr-3 label button_questionnaire"
            id="nextbutton"
          >
            Seguinte
          </div>
          <div class="arrow float-left">
            <div class="linha"></div>
            <div class="triangulo"></div>
          </div>
        </div>

        <div
          v-if="this.section === 'S6'"
          class="sabermais w-100 d-flex align-items-center transition btnSubmitText"
          v-on:click="submitForm()"
        >
          <div v-if="this.section === 'S6'" class="button" id="nextbutton">
            <span>Submeter</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
// import component for searchable dropdown
import Multiselect from 'vue-multiselect';
import eventBus from '@/eventBus.js';

export default {
  components: {
    Multiselect,
  },

  // Send to the parent component
  emits: [
    'save-answers', // method that sends answers to backend
    'change-section', // method to replace section with new section
    'error-handling', // handle error messages
    'download-template', // download template from backend
  ],

  // Receives from the parent component:
  props: [
    'questions', // Array of questions for selected section
    'section', // String with current section of the survey
    'sections', // Dictionary of unique sections {id:[description,logo]}
    'survey', // All the questions in the survey
    'questionMap',
    'allQuestionIds', // All question ids
    'CAE', // all CAES to display in the dropdown
    'Municipalities', // all municipalities to display in the dropdown
  ],

  // Data properties of this component
  data() {
    return {
      selectedAnswers: {}, // Dictionary of arrays with user responses {question_Id: [{Answer_Id: '', User_Answer: ''}, {Answer_Id: '', User_Answer: ''}, ...]}
      filledSections: new Set(), // Sections that have all questions answered
      validationTriggered: false, // Trigger to display CSS of unanswered question when user tries to submit form
      invalidQuestions: [], // Array with Ids of questions that are not answered, when user tries to change section/submit form
      invalidProducts: [], // Array with index and fields of empty fields in products table
      invalidProductFields: [], //
      invalidLocationIndexes: [], // indexes of rows in the location data that are invalid
      showSubmissionCheck: false, // Control the visibility of the final submission check with unanswered questions
      fileUploadError: null, // Error message with size of invalid document
      priorYear: null, // Gets current year -2 (on 1st of april it's updated for new values)
      currentYear: null, // Gets current year -1 (on 1st of april it's updated for new values)
      percentageTrigger: false, // trigger to show warning in the percentage question
      zipTrigger: false, // trigger to show warning in the zip question
      productTrigger: false,
      Company_Cae: '', // stores CAE object that is then set in the selectedAnswers
      groupedInvalidQuestions: {}, // inavlidquestions grouped by section and ordered, to display in final pop up
      Location_Data: [
        // data about company locations
        {
          description: '',
          address: '',
          postal_Code: '',
          municipality: '',
          cele: false,
        },
      ],
      fileInputKey: Date.now(), // Unique key for the file input element
    };
  },

  // When app is mounted do this:
  created() {
    this.loadAnswersFromLocalStorage(); // Load data from local storage
    this.loadFilledSectionsFromLocalStorage(); // Load filledSections from local storage
    this.loadInvalidQuestionsFromLocalStorage();
    this.initializeSelectedAnswers(); // Initialize each answer array in selectedAnswers
    document.addEventListener('click', this.handleGlossaryClick); // Add event listener for * clicks in text to open glossary
    this.updateYears(); // sets the PY and CY variables to the correct values based on the current date
  },

  mounted() {
    window.onbeforeunload = () => {
      this.validateSection();

      // show pop up if there are files uploaded and user tries to leave survey
      if (
        (this.selectedAnswers['Q0.7'] &&
          this.selectedAnswers['Q0.7'].length !== 0) ||
        (this.selectedAnswers['Q6.1'] &&
          this.selectedAnswers['Q6.1'].length !== 0) ||
        (this.selectedAnswers['Q6.2'] &&
          this.selectedAnswers['Q6.2'].length !== 0)
      ) {
        event.returnValue = 'Placeholder';
        return event.returnValue;
      }
    };
  },

  // before app unmounts do this:
  beforeUnmount() {
    document.removeEventListener('click', this.handleGlossaryClick); // Remove event listener for * clicks in text to open glossary
    window.onbeforeunload = null; // Clean up the event listener
  },

  // Watch for changes in:
  watch: {
    // selectedAnswers and save changes to localStorage
    selectedAnswers: {
      deep: true,
      handler: function (newValue) {
        // Create a copy of newValue to filter out file upload questions
        const filteredValue = { ...newValue };

        // List of questions to filter out
        const fileUploadQuestions = ['Q0.7', 'Q6.1', 'Q6.2'];

        // Remove file upload questions from filteredValue
        fileUploadQuestions.forEach((questionId) => {
          delete filteredValue[questionId];
        });

        localStorage.setItem('selectedAnswers', JSON.stringify(filteredValue));
      },
    },

    // filledSections and save changes to localStorage
    filledSections: {
      deep: true,
      handler: function (newValue) {
        localStorage.setItem(
          'filledSections',
          JSON.stringify(Array.from(newValue))
        );
      },
    },

    invalidQuestions: {
      deep: true,
      handler: function (newValue) {
        localStorage.setItem(
          'invalidQuestions',
          JSON.stringify(Array.from(newValue))
        );
      },
    },

    // Watch for changes in the 'description.val' property
    section: {
      // save changes to localStorage
      deep: true,
      handler: function (newValue) {
        localStorage.setItem('lastSection', newValue);
        this.initializeSelectedAnswers();

        // Add all questions to the invalidQuestion at the start (they are removed as they are filled)
        this.validateSection();
      },
    },

    // Watch for changes in the 'description.val' property
    Location_Data: {
      // save changes to localStorage
      deep: true,
      handler: function (newValue) {
        localStorage.setItem('Location_Data', JSON.stringify(newValue));
      },
    },

    // Watch for changes in the 'cae.val' property
    Company_Cae: function (newValue) {
      // Save the updated value to local storage
      localStorage.setItem('Company_Cae', JSON.stringify(newValue));

      // Check if newValue is empty
      if (newValue && newValue.id !== '') {
        // Store the value in the selected answers
        this.selectedAnswers['Q0.2'] = [
          { Answer_Id: 'A0.2_1', User_Answer: newValue.id },
        ];
        this.resetValidation('Q0.2');
      } else {
        // If newValue is empty, set the selectedAnswers entry to empty
        this.selectedAnswers['Q0.2'] = [];
      }
    },
  },

  // Computed properties
  computed: {
    // Gets the first section with unanswered questions to direct user
    firstUnansweredSection() {
      const sections = this.groupedInvalidQuestions;
      for (const section in sections) {
        if (Object.prototype.hasOwnProperty.call(sections, section)) {
          return 'S' + section.charAt(0);
        }
      }
      return null;
    },

    sectionDescription() {
      const currentSection = this.sections.find(
        (sec) => sec.section_Id === this.section
      );
      return currentSection ? currentSection.section_Desc : ''; // Return an empty string if not found
    },
  },

  // Methods:
  methods: {
    //////////////////////////////
    // Methods called on mount ///
    //////////////////////////////

    // Method to load answers from local storage to selectedAnswers
    loadAnswersFromLocalStorage() {
      const storedAnswers = localStorage.getItem('selectedAnswers');
      if (storedAnswers) {
        // Check if answers exist in local storage
        this.selectedAnswers = JSON.parse(storedAnswers); // Parse and set the stored answers to selectedAnswers
      } else {
        // if selectedanswers is deleted in localstorage, also delete filledSections
        localStorage.removeItem('filledSections');
      }
      if (localStorage.getItem('Location_Data')) {
        // Set the value of 'municipality' from local storage
        const storedLocation_Data = localStorage.getItem('Location_Data');
        if (storedLocation_Data && storedLocation_Data?.length > 0) {
          // Check if answers exist in local storage
          this.Location_Data = JSON.parse(storedLocation_Data);
        }
      }
      if (localStorage.getItem('Company_Cae')) {
        // Set the value of 'cae' from local storage
        const storedCompany_Cae = localStorage.getItem('Company_Cae');
        if (storedCompany_Cae) {
          // Check if answers exist in local storage
          this.Company_Cae = JSON.parse(storedCompany_Cae);
        }
      }
    },

    // Method to load filledSections from local storage
    loadFilledSectionsFromLocalStorage() {
      const storedFilledSections = localStorage.getItem('filledSections');
      if (storedFilledSections) {
        // Check if it exist in local storage
        const storedArray = JSON.parse(storedFilledSections); // Parse and set the filledSections locally
        this.filledSections = new Set(storedArray);
      }
    },

    loadInvalidQuestionsFromLocalStorage() {
      const storedInvalidQuestions = localStorage.getItem('invalidQuestions');
      if (storedInvalidQuestions) {
        // Check if it exist in local storage
        this.invalidQuestions = JSON.parse(storedInvalidQuestions);
      }
    },

    // Method to initialize all questions from the current section as empty arrays
    initializeSelectedAnswers() {
      this.questions.forEach((question) => {
        if (question.subQuestion.length > 0) {
          // Initialize an array for each subQuestion
          question.subQuestion.forEach((subQuestion) => {
            if (!this.selectedAnswers[subQuestion.subQuestion_Id]) {
              this.selectedAnswers[subQuestion.subQuestion_Id] = [];
              if (question.question_Type === 'MultiCheckbox') {
                Object.entries(subQuestion.answers).forEach(([key]) => {
                  this.selectedAnswers[subQuestion.subQuestion_Id].push({
                    Answer_Id: key,
                    User_Answer: 'false',
                  });
                });
              }
            }
          });
        } else {
          // For other questions
          if (question.question_Type === 'UserInputDetail') {
            // If its product table
            if (!this.selectedAnswers[question.question_Id]) {
              // initialize the first answer to show 1 row
              this.selectedAnswers[question.question_Id] = [
                { Answer_Id: 'A0.6_1', User_Answer: ':' },
              ];
            }

            // Initialize an array for simple question
          } else if (
            !this.selectedAnswers[question.question_Id] &&
            !question.question_Type !== 'FileUpload'
          ) {
            this.selectedAnswers[question.question_Id] = [];
          }
        }
      });
    },

    // Method to update current and prior years
    updateYears() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth(); // months start from 0
      if (month > 2) {
        // After April 1st
        this.currentYear = year - 1;
        this.priorYear = year - 2;
      } else {
        // Before April 1st
        this.currentYear = year - 2;
        this.priorYear = year - 3;
      }
    },

    ////////////////////////////
    // Event handler methods ///
    ////////////////////////////

    // Handle answers from Inputs (Text and Number)
    handleUserInput(question_Id, answer_Id, value) {
      if (value.length === 0 || value.trim() === '') {
        // If user entered empty string
        if (question_Id === 'Q0.4' || question_Id === 'Q3.2') {
          // For the userinputs in the checkbox questions, simply insert ''
          const item = this.selectedAnswers[question_Id].find(
            (item) => item.Answer_Id === answer_Id
          );
          item.User_Answer = value;
        } else {
          // For normal userinputs
          delete this.selectedAnswers[question_Id]; // Remove the answer from the selectedAnswers and filledSection
          this.filledSections.delete(this.section);
        }
      } else {
        // If user entered valid string
        if (
          // If answer_Id already in selectedanswers (checkbox cases)
          this.selectedAnswers[question_Id] !== undefined &&
          this.selectedAnswers[question_Id].findIndex(
            (item) => item.Answer_Id === answer_Id
          ) !== -1
        ) {
          const item = this.selectedAnswers[question_Id].find(
            (item) => item.Answer_Id === answer_Id
          );
          item.User_Answer = value; // simply set the User_Answer value
          this.resetValidation(question_Id);

          // If not, set the answer_Id and the inputed value to the selectedAnswers
        } else {
          this.selectedAnswers[question_Id] = [
            { Answer_Id: answer_Id, User_Answer: value },
          ];
        }
      }
      this.$emit('error-handling', '');
    },

    // Handle answers from Inputs (singleselectbylevel)
    handleUserInputSSBL(question_Id, answer_Id, value) {
      // If user entered valid string
      if (
        // If answer_Id already in selectedanswers (checkbox cases)
        this.selectedAnswers[question_Id] !== undefined &&
        this.selectedAnswers[question_Id].findIndex(
          (item) => item.Answer_Id === answer_Id
        ) !== -1
      ) {
        const item = this.selectedAnswers[question_Id].find(
          (item) => item.Answer_Id === answer_Id
        );
        if (item.User_Answer === value) {
          this.selectedAnswers[question_Id] = [];
          this.filledSections.delete(this.section);
        } else {
          item.User_Answer = value; // simply set the User_Answer value
        }
        this.resetValidation(question_Id);

        // If not, set the answer_Id and the inputed value to the selectedAnswers
      } else {
        this.selectedAnswers[question_Id] = [
          { Answer_Id: answer_Id, User_Answer: value },
        ];
      }
      this.$emit('error-handling', '');
    },

    getUserInputValue(question_Id, answer_Id, getFullValue = true) {
      const item = this.selectedAnswers[question_Id]?.find(
        (item) => item.Answer_Id === answer_Id
      );

      if (item) {
        if (getFullValue) {
          return item.User_Answer; // Return the full User_Answer
        } else {
          // Return the part after the colon, or an empty string if it doesn't exist
          const parts = item.User_Answer.split(':');
          return parts.length > 1 ? parts[1] : '';
        }
      }
      return '';
    },

    // Format with dot as thousands separator
    formatNumber(value) {
      if (value >= 1000) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return value; // Return the number as is if less than 1000
    },

    handleUserDetailInput(question_Id, answer_Id, value, box) {
      // Replace any ':' entered by the user with '-'
      value = value.replace(/:/g, '-');

      if (value.length === 0 || value.trim() === '') {
        this.filledSections.delete(this.section);
      }
      // Find the answer object in selectedAnswers
      let answer = this.selectedAnswers[question_Id].find(
        (item) => item.Answer_Id === answer_Id
      );

      // Split the existing User_Answer into name and process
      let [name, process] = answer.User_Answer.split(':');

      // Update the appropriate value based on the box parameter
      if (box === 'name') {
        name = value;
        // Remove the invalid entry for 'name' if it exists
        this.invalidProductFields = this.invalidProductFields.filter(
          (item) => !(item.Answer_Id === answer_Id && item.Text_Part === 'name')
        );
      } else if (box === 'process') {
        process = value;
        // Remove the invalid entry for 'process' if it exists
        this.invalidProductFields = this.invalidProductFields.filter(
          (item) =>
            !(item.Answer_Id === answer_Id && item.Text_Part === 'process')
        );
      }

      // Concatenate the name and process with a colon separator
      answer.User_Answer = `${name || ''}:${process || ''}`;
      this.resetValidation(question_Id);
    },

    // Handle answers from SingleSelect questions (radio buttons)
    handleRadioChange(question_Id, answer_Id) {
      this.resetValidation(question_Id);

      const existingAnswerIndex = this.selectedAnswers[question_Id]?.findIndex(
        (answer) => answer.Answer_Id === answer_Id
      );

      if (existingAnswerIndex !== -1) {
        this.selectedAnswers[question_Id].splice(existingAnswerIndex, 1);
        this.filledSections.delete(this.section);
      } else {
        this.selectedAnswers[question_Id] = [
          { Answer_Id: answer_Id, User_Answer: '' },
        ];
      }
    },

    //Handle checkBoxes
    handleCheckbox(questionId, answer_Id) {
      this.resetValidation(questionId);
      const index = this.selectedAnswers[questionId].findIndex(
        (item) => item.Answer_Id === answer_Id
      );

      if (this.isChecked(questionId, answer_Id, 'true')) {
        // Update the existing object at the found index
        this.selectedAnswers[questionId][index] = {
          ...this.selectedAnswers[questionId][index],
          Answer_Id: answer_Id,
          User_Answer: 'false',
        };
      } else {
        this.selectedAnswers[questionId][index] = {
          ...this.selectedAnswers[questionId][index],
          Answer_Id: answer_Id,
          User_Answer: 'true',
        };
      }

      if (index === -1) {
        this.selectedAnswers[questionId].push({
          Answer_Id: answer_Id,
          User_Answer: 'true',
        });
      }
    },

    // Handle answers from MultiSelect questions (checkboxes)
    handleMultiSelect(question_Id, answer_Id, question_text) {
      this.resetValidation(question_Id);

      if (!this.isChecked(question_Id, answer_Id)) {
        // Check if the selected answer is 'N/S'
        if (question_text === 'Não sei' || question_text === 'Não aplicável') {
          // Clear all other selected answers
          this.selectedAnswers[question_Id] = [
            {
              Answer_Id: answer_Id,
              User_Answer: '',
            },
          ];
        } else {
          // If 'N/S' is already selected, remove it from selected answers
          const nsIndex1 = this.selectedAnswers[question_Id].findIndex(
            (item) => item.Answer_Id === 'A1.6_5' // 'N/S' Answer_Id
          );
          const nsIndex2 = this.selectedAnswers[question_Id].findIndex(
            (item) => item.Answer_Id === 'A4.2_5' // 'N/S' Answer_Id
          );
          const nsIndex3 = this.selectedAnswers[question_Id].findIndex(
            (item) => item.Answer_Id === 'A3.2_10' // 'N/S' Answer_Id
          );
          if (nsIndex1 !== -1) {
            this.selectedAnswers[question_Id].splice(nsIndex1, 1);
          }
          if (nsIndex2 !== -1) {
            this.selectedAnswers[question_Id].splice(nsIndex2, 1);
          }
          if (nsIndex3 !== -1) {
            this.selectedAnswers[question_Id].splice(nsIndex3, 1);
          }

          // Add the answer if checked
          this.selectedAnswers[question_Id].push({
            Answer_Id: answer_Id,
            User_Answer: '',
          });
        }
      } else {
        // Remove the answer if unchecked
        const index = this.selectedAnswers[question_Id].findIndex(
          (item) => item.Answer_Id === answer_Id
        );
        if (index !== -1) {
          this.selectedAnswers[question_Id].splice(index, 1);
        }
        if (this.selectedAnswers[question_Id].length === 0) {
          this.filledSections.delete(this.section);
        }
      }
    },

    // Handle multiple user inputs for MultiUserInput types
    handleUserInputSubQuestions(subQuestion_Id, answer_Id, value) {
      if (value.length === 0 || value.trim() === '') {
        const index = this.selectedAnswers[subQuestion_Id].findIndex(
          (item) => item.Answer_Id === answer_Id
        );
        if (index !== -1) {
          this.selectedAnswers[subQuestion_Id].splice(index, 1);
        }
        // Remove the section from filledSections
        this.filledSections.delete(this.section);
      } else {
        // Check if an entry with the same Answer_Id already exists
        const existingEntryIndex = this.selectedAnswers[
          subQuestion_Id
        ].findIndex((item) => item.Answer_Id === answer_Id);

        if (existingEntryIndex !== -1) {
          // Replace the existing entry's User_Answer
          this.selectedAnswers[subQuestion_Id][existingEntryIndex].User_Answer =
            value;
        } else {
          // Push a new entry if it doesn't exist
          this.selectedAnswers[subQuestion_Id].push({
            Answer_Id: answer_Id,
            User_Answer: value,
          });
        }
      }
      this.$emit('error-handling', '');
    },

    // Handle File Uploads
    async handleFileUpload(question_Id, answer_Id, event) {
      //Get the file uploaded from the event
      const file = event.target.files[0];
      if (file) {
        delete this.selectedAnswers[question_Id]; // Delete previous file
        const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
        if (file.size > maxSizeInBytes) {
          // If the file is bigger than 10MB emit error
          this.fileUploadError =
            'O ficheiro tem ' +
            Math.round(file.size / 1000000) +
            'MB, mas só pode ter no máximo 10MB';
          return;
        } else {
          this.fileUploadError = null;
        }
        try {
          // If its not bigger
          const base64String = await this.convertToBase64(file); //Convert the file to Base64

          //Add the file to the selectedAnswers
          this.selectedAnswers[question_Id] = {
            Answer_Id: answer_Id,
            //Store the file in the selectedAnswers object separated by a semicolon
            FileName: file.name,
            FileContent: base64String,
          };
        } catch (error) {
          console.error('Error converting file to base64:', error);
        }
      }
    },

    // Checks for clicks in * and shows glossary
    handleGlossaryClick(event) {
      if (
        event.target.classList.contains('glossary-term') ||
        event.target.classList.contains('glossary-term-cele')
      ) {
        eventBus.$emit('show-glossary', event.target.innerText);
      }
    },

    // Checks for clicks and shows submission check
    handleSubmitionCheck() {
      this.showSubmissionCheck = true;
    },

    // Method to download file
    handleDownloadTemplate() {
      // Emit the download-file event
      this.$emit('download-template');
    },

    // Remove the uploaded file
    removeUploadedFile(question_Id) {
      delete this.selectedAnswers[question_Id];
      this.selectedAnswers[question_Id] = [];
      this.fileInputKey = Date.now(); // Update the key to force re-render
    },

    //Handle the change of section (stepper or buttons)
    changeSection(toSection, moveForward) {
      this.fileUploadError = null;
      let newSection = null;
      if (this.section == 'S0') {
        this.passLocationDataToAnswers(); // pass the location data object to the corresponding questionid in selectedanswers as a formatted string
      }

      // If user used stepper:
      if (moveForward === null || moveForward === undefined) {
        newSection = toSection; // set newSection to the selected section in stepper
      }

      // If user changed section in buttons:
      else {
        const firstChar = this.section.charAt(0); // Get the 1st characetr of the section ('S')
        const restOfSection = this.section.slice(1); // Convert the second part of the section to an integer
        let newRestOfSection;
        if (moveForward) {
          // If user wants to move forward:
          newRestOfSection = parseInt(restOfSection, 10) + 1; // Add 1 to the integer part of the section
        } else {
          // If user wants to move back:
          newRestOfSection = parseInt(restOfSection, 10) - 1; // Subtract 1 to the integer part of the section
        }
        newSection = firstChar + newRestOfSection; // Remerge the first character ('S') with the changed integer
      }

      this.validateSection(); // get invalid questions of the section

      if (
        // if the percentage question has a value, and that value is invalid
        this.invalidQuestions.includes('Q5.5') &&
        Array.isArray(this.selectedAnswers['Q5.5']) &&
        this.selectedAnswers['Q5.5']?.length > 0
      ) {
        this.percentageTrigger = true; // activate the trigger that shows error
        this.scrollToBottom(); // scroll to the question for user to see the error
        return; // dont allow user to change section
      }

      if (this.section == 'S0') {
        let invalidPostalCodeFound = false;

        this.Location_Data.forEach((_, index) => {
          if (this.isInvalidPostalCode(index)) {
            invalidPostalCodeFound = true;
            this.zipTrigger = true; // activate the trigger that shows error
            this.scrollToZip(); // scroll to the question for user to see the error
            return; // exit the loop early
          }
        });

        if (invalidPostalCodeFound) {
          return; // don't allow user to change section
        }
      }

      // If all checks passed, change section
      this.$emit('change-section', newSection);

      // Only scrolls up if the user used buttons
      if (moveForward !== null || moveForward === undefined) {
        this.scrollToTop();
      }
    },

    // Method to filter out invalid answers
    filterInvalidAnswers(question_Id) {
      if (this.selectedAnswers[question_Id]) {
        if (question_Id === 'Q0.1') {
          // Split the answer by ';'
          let parts =
            this.selectedAnswers[question_Id][0]?.User_Answer.split(';');
          // Filter out parts that contain '____false' or '___null_false'
          const filteredParts = parts.filter(
            (part) => part !== '____false' && part !== '___null_false'
          );

          // Check if all parts were invalid
          if (filteredParts.length === 0) {
            // If all parts are invalid, reset to initialized state
            this.selectedAnswers[question_Id][0].User_Answer = ':'; // Keep one empty line
            this.Location_Data = [
              {
                description: '',
                address: '',
                postal_Code: '',
                municipality: '',
                cele: false,
              },
            ];
          } else {
            // Join the valid parts back together with ';'
            this.selectedAnswers[question_Id][0].User_Answer =
              filteredParts.join(';');

            // Parse the filtered locations back into the Location_Data object
            this.Location_Data = filteredParts.map((part) => {
              const [description, address, postal_Code, municipality, cele] =
                part.split('_');
              return { description, address, postal_Code, municipality, cele };
            });

            // Store the updated Location_Data object in localStorage
            localStorage.setItem(
              'Location_Data',
              JSON.stringify(this.Location_Data)
            );
          }
        } else if (question_Id === 'Q0.6') {
          // Filter out answers where the name part (before the ':') is empty
          this.selectedAnswers[question_Id] = this.selectedAnswers[
            question_Id
          ].filter((answer) => {
            const [name] = answer.User_Answer.split(':');
            return name.trim() !== '';
          });

          // Check if all answers are invalid
          if (this.selectedAnswers[question_Id].length === 0) {
            // If all answers are invalid, reset to initialized state
            this.selectedAnswers[question_Id] = [
              { Answer_Id: 'A0.6_1', User_Answer: ':' }, // Keep one empty line
            ];
          }
        }
      }
    },

    // Handle form submission
    submitForm(finalSubmit) {
      this.filterInvalidAnswers('Q0.1');
      this.filterInvalidAnswers('Q0.6');
      this.validateSection();

      // reset validation trigger
      this.validationTriggered = false;

      // Retrieve the companyInformation object from localStorage
      const companyInformation = JSON.parse(
        localStorage.getItem('companyInformation')
      );

      const companyId = companyInformation.Company_Id;

      // if there are no invalid questions:
      if (finalSubmit !== undefined || this.invalidQuestions.length === 0) {
        const payload = {
          selectedAnswers: this.selectedAnswers,
          currentYear: this.currentYear,
          priorYear: this.priorYear,
          Company_Id: companyId,
        };
        this.$emit('save-answers', payload);
      } else {
        const idsToRemove = [
          'Q1.4',
          'Q2.2',
          'Q2.4',
          'Q6.3',
          'Q0.3',
          'Q0.7',
          'Q6.1',
          'Q6.2',
        ];
        // if there are invalid questions
        // Add questions that were not answered and were never initialized
        this.allQuestionIds.forEach((questionId) => {
          // Check if any key in selectedAnswers starts with the current questionId
          const hasMatchingAnswer = Object.keys(this.selectedAnswers).some(
            (key) => key.startsWith(questionId)
          );

          // If no matching answer is found and the questionId is not already in invalidQuestions, add it
          if (
            !hasMatchingAnswer &&
            !this.invalidQuestions.includes(questionId) &&
            !idsToRemove.includes(questionId)
          ) {
            this.invalidQuestions.push(questionId);
          }
        });
        this.resetValidation('Q1.2'); // never show Q1.2 as invalid
        this.calculateGroupedInvalidQuestions(); // get the invalid questions grouped by section and ordered
        this.handleSubmitionCheck(); // show the pop up with invalid questions
      }
    },

    // when user wants to revise the survey to answer unanswered questions
    reviseSurveyWithValidation() {
      this.validationTriggered = true; // show css on unanswered questions
      this.changeSection(this.firstUnansweredSection); // go to the first section that has unanswered questions
      this.showSubmissionCheck = false; // remove pop up
    },

    ////////////////////////
    // Data Manipulation ///
    ////////////////////////

    //////////////////////////////////////////////
    // Methods for the Locations table question //
    // Add another row to the table
    addRowLocalizations() {
      if (!this.validateLocations()) {
        // check if all rows are valid
        return; // dont add a row if tere is an invalid row (and display css)
      } else {
        // if they are all valid
        this.Location_Data.push({
          // push another row
          description: '',
          address: '',
          postal_Code: '',
          municipality: '',
          cele: false,
        });
      }
    },

    // Remove row from the table
    removeRowLocalizations(index) {
      this.Location_Data.splice(index, 1); // receives index of the row we want to remove and splices it from the object

      // check if table is empty after removing, if yes remove section from filledSections
      if (!this.validateLocations()) {
        this.filledSections.delete(this.section);
      }
    },

    // Method to check which rows are not filled in the locations table
    validateLocations() {
      this.invalidLocationIndexes = []; // Reset invalid fields
      for (let i = 0; i < this.Location_Data.length; i++) {
        // for every row of the locations
        const row = this.Location_Data[i];
        if (
          // check if all fields are empty (one field answered is enough to validate row)
          !row.description &&
          !row.address &&
          (!row.postal_Code || row.postal_Code.length !== 8) &&
          (!row.municipality || row.municipality === null)
        ) {
          // if no field is filled push the row index to invalid indexes
          this.invalidLocationIndexes.push(i);
        }
      }
      return this.invalidLocationIndexes.length === 0; // Return true if no invalid fields
    },

    // Method to display css on invalid rows
    isInvalidLocation(index) {
      // receives index of row
      return this.invalidLocationIndexes.some(
        // returns true if the index is on the invalid indexes array to activate the class that displays the css
        (invalidIndex) => invalidIndex === index
      );
    },

    // Method to check if specific Zip is invalid
    isInvalidPostalCode(index) {
      return (
        this.Location_Data[index].postal_Code?.length !== 8 &&
        this.Location_Data[index].postal_Code !== ''
      );
    },

    // Method called to remove invalid css of row when user clicks any field
    removeInvalidLocation(index) {
      // receives index of row
      this.invalidLocationIndexes = this.invalidLocationIndexes.filter(
        // removes that index from the invalid indexes array
        (invalidIndex) => !(invalidIndex === index)
      );
      this.zipTrigger = false;
    },

    // method called on submit to pass the information of the locations object to selectedansweres as a formatted string
    passLocationDataToAnswers() {
      // Concatenate the fields of each location with underscores
      const concatenatedLocations = this.Location_Data.map((location) => {
        return `${location?.description}_${location.address}_${location.postal_Code}_${location.municipality}_${location.cele}`;
      }).join(';'); // Concatenate all locations with semicolons

      // Store the concatenated string in the User_Answer property of the selectedAnswers object
      this.selectedAnswers['Q0.1'] = [
        { Answer_Id: 'A0.1_1', User_Answer: ':' },
      ];
      this.selectedAnswers['Q0.1'][0].User_Answer = concatenatedLocations;
    },

    /////////////////////////////////////////////
    // Methods for the Products table question //
    // Method to add row to product table
    addRowProducts(question_Id) {
      const questionQ05 = this.questions.find(
        (question) => question.question_Id === question_Id
      );
      if (!this.calculateinvalidProductFields(question_Id)) {
        this.productTrigger = true;
        // don't add row if there are invalid fields
        return;
      }
      if (questionQ05) {
        const allIdsQ05 = Object.keys(questionQ05.answers); // get all possible ids of the question
        const nextId = allIdsQ05.find(
          // find the next id that is not yet answered
          (id) =>
            !this.selectedAnswers[question_Id].some(
              (answer) => answer.Answer_Id === id
            )
        );
        if (nextId) {
          // if there is a next id, push it (add row with this id)
          this.selectedAnswers[question_Id].push({
            Answer_Id: nextId,
            User_Answer: ':',
          });
        }
      }
    },

    // Method to remove row
    removeRowProducts(question_Id, answer_Id) {
      this.selectedAnswers[question_Id] = this.selectedAnswers[question_Id] // filter the id to remove from the answers
        .filter((answer) => answer.Answer_Id !== answer_Id);

      // check if table is empty after removing, if yes remove section from filledSections
      if (!this.calculateinvalidProductFields(question_Id)) {
        this.filledSections.delete(this.section);
      }
    },

    calculateinvalidProductFields(question_Id) {
      this.invalidProductFields = []; // Reset invalid data array

      const answers = this.selectedAnswers[question_Id];
      if (answers) {
        answers.forEach((item) => {
          const [name, process] = item.User_Answer.split(':');
          if (!name) {
            this.invalidProductFields.push({
              Answer_Id: item.Answer_Id,
              Text_Part: 'name',
            });
          }
          if (!process) {
            this.invalidProductFields.push({
              Answer_Id: item.Answer_Id,
              Text_Part: 'process',
            });
          }
        });
      }
      return this.invalidProductFields?.length === 0; // Return true if no invalid data
    },

    // Check if the product name is empty
    isProductNameEmpty(question_Id, answer_Id) {
      const answer = this.selectedAnswers[question_Id]?.find(
        (item) => item.Answer_Id === answer_Id
      );
      return !answer || answer.User_Answer === ':';
    },

    isFieldInvalid(answer_Id, textPart) {
      // receives answer_Id and text part to check
      return this.invalidProductFields.some(
        (item) => item.Answer_Id === answer_Id && item.Text_Part === textPart
      );
    },

    ////////////////////////////////////////////
    // Methods to handle questions in general //

    // Unanswered questions grouped by section to display in the final pop-up
    calculateGroupedInvalidQuestions() {
      const sections = {};

      // Create a mapping of section numbers to their descriptions
      const sectionMap = {};
      this.sections.forEach((section) => {
        const sectionNumber = section.section_Id.replace('S', ''); // Extract the number from section_Id
        sectionMap[sectionNumber] = section.section_Desc; // Map number to description
      });

      // Extract section number and group questions by section
      this.invalidQuestions.forEach((question) => {
        const match = question.match(/^Q(\d+)\./);
        if (match) {
          const sectionNumber = match[1];
          if (!sections[sectionNumber]) {
            sections[sectionNumber] = [];
          }
          sections[sectionNumber].push(question);
        }
      });

      // Create a new object for grouped invalid questions
      const groupedInvalidQuestions = {};

      // Sort the questions within each section and format the keys
      for (const section in sections) {
        sections[section].sort((a, b) => {
          const aQuestionNumber = parseInt(a.match(/^Q\d+\.(\d+)/)[1], 10);
          const bQuestionNumber = parseInt(b.match(/^Q\d+\.(\d+)/)[1], 10);
          return aQuestionNumber - bQuestionNumber;
        });

        // Update the section key to include the description
        const sectionDescription = sectionMap[section];
        if (sectionDescription) {
          const newKey = `${section} - ${sectionDescription}`; // Create the new key
          groupedInvalidQuestions[newKey] = sections[section]; // Assign the questions to the new key
        }
      }

      this.groupedInvalidQuestions = groupedInvalidQuestions; // Assign the new grouped sections to the reactive property
    },

    // Method to check if answer is selected and display css
    isChecked(question, key, userAnswer = null) {
      // Question Type SingleSelectByLevel and checkboxes - In these cases, it is necessary to check the selected answer and the user answer
      if (userAnswer) {
        return (
          this.selectedAnswers[question]?.findIndex(
            (item) => item.Answer_Id === key && item.User_Answer === userAnswer
          ) !== -1
        );

        // Other Question Types
      } else {
        return (
          this.selectedAnswers[question]?.findIndex(
            (item) => item.Answer_Id === key
          ) !== -1
        );
      }
    },

    // Method to remove red color from unanswered questions
    resetValidation(question_Id) {
      this.invalidQuestions = this.invalidQuestions.filter(
        (id) => id !== question_Id
      );
    },

    // Get array of questions that are not answered in the section
    validateSection() {
      let invalidQuestions = [];
      this.questions.forEach((question) => {
        if (question.subQuestion && question.subQuestion.length > 0) {
          // Check for subquestions with answers
          const answeredSubQuestions = Object.keys(this.selectedAnswers).filter(
            (key) => key.startsWith(question.question_Id)
          );

          // Sum the number of objects in each subQuestion
          const totalAnswered = answeredSubQuestions.reduce((sum, key) => {
            return sum + this.selectedAnswers[key].length;
          }, 0);

          // Compare the total number of answered subQuestions with the expected number
          const expectedTotal = question.subQuestion.reduce(
            (sum, record) => sum + Object.keys(record.answers).length,
            0
          );
          if (totalAnswered !== expectedTotal) {
            invalidQuestions.push(question.question_Id);
          }
        } else {
          // Check if the main question is answered
          const answer = this.selectedAnswers[question.question_Id];
          if (!answer || (Array.isArray(answer) && answer.length === 0)) {
            invalidQuestions.push(question.question_Id);
          } // Other special cases

          if (question.question_Id === 'Q3.2') {
            // If question is 3.2, check if the text is also filled
            const index = this.selectedAnswers[question.question_Id].findIndex(
              (item) => item.Answer_Id === 'A3.2_9'
            );
            if (index !== -1) {
              if (
                this.selectedAnswers[question.question_Id][index]
                  .User_Answer === ''
              ) {
                invalidQuestions.push(question.question_Id);
              }
            }
          } else if (question.question_Id === 'Q0.5') {
            // If question is 0.5, check if the text is also filled
            const index = this.selectedAnswers[question.question_Id].findIndex(
              (item) => item.Answer_Id === 'A0.5_12'
            );
            if (index !== -1) {
              if (
                this.selectedAnswers[question.question_Id][index]
                  .User_Answer === ''
              ) {
                invalidQuestions.push(question.question_Id);
              }
            }
          } else if (question.question_Id === 'Q0.6') {
            // Call the filterInvalidAnswers method to clean up the answers
            this.filterInvalidAnswers(question.question_Id);

            if (!this.calculateinvalidProductFields(question.question_Id)) {
              this.productsInvalid = true;
              invalidQuestions.push(question.question_Id);
            }
          } else if (question.question_Id === 'Q5.5') {
            // If question is 5.5, check if the value is between 0-100
            if (Array.isArray(this.selectedAnswers[question.question_Id])) {
              const answer =
                this.selectedAnswers[question.question_Id][0]?.User_Answer;
              if (!/^(100|\d{1,2}(\.\d+)?)$/.test(answer)) {
                invalidQuestions.push(question.question_Id);
              }
            } else {
              invalidQuestions.push(question.question_Id);
            }
          } else if (question.question_Id === 'Q0.1') {
            // If question is 0.1, check if the answer is empty
            if (
              this.selectedAnswers[
                question.question_Id
              ][0]?.User_Answer?.startsWith('____') ||
              this.selectedAnswers[
                question.question_Id
              ][0]?.User_Answer?.startsWith('___null_')
            ) {
              invalidQuestions.push(question.question_Id);
              this.filledSections.delete(this.section);
            }
          }
        }
      });

      // Define the IDs to remove
      const idsToRemove = [
        'Q1.4',
        'Q2.2',
        'Q2.4',
        'Q6.3',
        'Q0.3',
        'Q0.7',
        'Q6.1',
        'Q6.2',
      ];
      invalidQuestions = invalidQuestions.filter(
        (id) => !idsToRemove.includes(id)
      );

      if (invalidQuestions.length === 0) {
        this.filledSections.add(this.section); // Add this section to the filledSections
      } else {
        invalidQuestions.forEach((questionId) => {
          if (!this.invalidQuestions.includes(questionId)) {
            this.invalidQuestions.push(questionId);
          }
        });
      }
    },

    ///////////////////////////////////
    // Methods to manipulate strings //

    // Method to format postal code in real time as the user types
    formatPostalCode(index, event) {
      let value = event.target.value;

      // Remove any non-digit characters
      value = value.replace(/\D/g, '');

      // Ensure the format is "four digits" "-" "three digits"
      if (value.length > 4) {
        value = value.slice(0, 4) + '-' + value.slice(4, 7);
      }

      // Update the item.Postal_Code with the formatted value
      this.Location_Data[index].postal_Code = value;
    },

    // Display in the CAE dropdown the id and description formatted
    idAndDescription({ id, description }) {
      return `${id} - ${description}`;
    },

    // Returns the question text with a clickable * to show glossary
    formatAsteriskQuestion(questionInfo) {
      if (questionInfo === undefined) {
        return;
      }

      // Construct the HTML string to show Id + Desc
      const questionDesc = `${questionInfo.question_Id}. ${questionInfo.question_Desc}`;

      // Replace * with a clickable span
      return questionDesc.replace(
        /\*/g,
        '<div class="glossary-tooltip"><span class="glossary-term">*</span><span class="tooltip-text">Ver glossário</span></div>'
      );
    },

    // Returns the answer text with a clickable * to show glossary
    formatAsteriskAnswer(answer) {
      if (answer === undefined) {
        return;
      }
      // Replace * with a clickable span
      return answer.replace(/\*/g, '<div class="glossary-tooltip"><span class="glossary-term">*</span><span class="tooltip-text">Ver glossário</span></div>');
    },

    //////////////////////
    // Utility methods ///
    //////////////////////

    // Handle scrolling to the top of the page
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },

    // Handle scrolling to the zip question
    scrollToZip() {
      window.scrollTo({
        top: 400,
        behavior: 'smooth',
      });
    },

    // Handle scrolling to the bottom of the page
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth',
      });
    },

    // Method to convert a file to base64
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result;
          resolve(base64String); //base64 string
        };
        reader.onerror = (error) => {
          console.error('Error converting file to base64:', error);
          reject(error); // Reject the promise with an error
        };
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
